$(function() {
  console.log('layout.js');

  // タブレットレイアウトをPCと統一
  var metaDiscre = document.head.children;
  var metaLength = metaDiscre.length;
  if(window.outerWidth > 700 && window.outerWidth < 1400){
    for(var i = 0;i < metaLength;i++){
       var proper = metaDiscre[i].getAttribute('name');
        if(proper === 'viewport'){
          var dis = metaDiscre[i];
          dis.setAttribute('content','width=1200');
        }
    }
  }

  function backgroundAnimation(){
    var gradetionBox = $('#gradetionBox');

    var max = 2.4;
    var max2 = 15;
    var max3 = 1.1;
    var propertyMax1 = 60;
    var propertyMax2 = 50;
    var propertyMax3 = 60;

    var min = 1.2;
    var min2 = -15;
    var min3 = 1;
    var propertyMin1 = 30;
    var propertyMin2 = 25;
    var propertyMin3 = 30;

    function setMoving(){
      var delay = 0;
      setTimeout(function() {
        var setNumber01 = Math.random() * (max - min) + min;
        var setNumber02 = Math.random() * (max - min) + min;
        var setNumber03 = Math.random() * (max3 - min3) + min3;
        var setNumber04 = Math.random() * (max2 - min2) + min2;
        var setNumber05 = Math.random() * (max2 - min2) + min2;
        var matrixProperty = 'matrix(' + setNumber01 +', 0, 0, '+ setNumber02 + ', 0, 0) translate3d('+ setNumber04 + '%,'+ setNumber05 + '%,0) scale(' + setNumber03 +')';

        var bgNumber01 = Math.random() * (propertyMax1 - propertyMin1) + propertyMin1;
        var bgNumber02 = Math.random() * (propertyMax2 - propertyMin2) + propertyMin2;
        var bgNumber03 = Math.random() * (propertyMax3 - propertyMin3) + propertyMin3;
        var bgProperty = 'radial-gradient(circle at ' + Math.ceil(bgNumber01) +'% ' + Math.ceil(bgNumber02) +'%, #F3CCBB 0%, #fff '+ Math.ceil(bgNumber03) +'%);';
        console.log('matrixProperty:' + matrixProperty);
        console.log('bgProperty:' + bgProperty);
        gradetionBox.stop().animate2({'transform': matrixProperty, 'background-image': bgProperty}, 3000);
        /*gradetionBox.attr('style', 'background-image:' + bgProperty + '; transform:' + matrixProperty);*/
      }, delay);
    }

    function getMoving(){
      setMoving();
      setTimeout(function() {
        init();
      }, 3000);
    }

    function init(){
      getMoving();
    }

    init();
  }

  backgroundAnimation()


  function preSetScript(){

    $.fn.animate2 = function (properties, duration, ease) {
      ease = ease || 'ease';
      var $this = this;
      var cssOrig = { transition: $this.css('transition') };
      return $this.queue(next => {
          properties['transition'] = 'all ' + duration + 'ms ' + ease;
          $this.css(properties);
          setTimeout(function () {
              $this.css(cssOrig);
              next();
          }, duration);
      });
    };

    //トップに戻るボタン + スクロール + ウィンドウサイズ系の対策処理
    function scrollAnimationSet(target) {
      const scButtonWrap = $('#scrollTopWrap');
      const indexProducts = document.getElementById("indexProducts");
      const position = document.documentElement;
      let wHeight = window.innerHeight;
      let preSetWidth = window.innerWidth;
      let scrollCount = 0;

      function setHeightProperty() {
        wHeight = window.innerHeight;
        position.style.setProperty('--wHeight', window.innerHeight);
        position.style.setProperty('--wHeightPx', window.innerHeight + 'px');
        position.style.setProperty('--scroll', window.scrollY);

        $(".effect").each(function() {
          var imgPos = $(this).offset().top;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll > imgPos - windowHeight + windowHeight / 7) {
            $(this).removeClass('effect');
          };
        });

        requestAnimationFrame(setHeightProperty);
      }

      function setProperties() {
        setHeightProperty();
      }

      function init() {
        /*const scrollButton = document.querySelector('#returnTop');
        scrollButton.addEventListener( 'click' , scrollTop );*/
        function scrollTop(){
          window.scroll({top: 0, behavior: 'smooth'});
        };
        var timer = false;
        setProperties();
        position.style.setProperty('--wHeightFixedPx', window.innerHeight + 'px');
        setProperties();
      }

      init();

    }

    scrollAnimationSet($('article'));

    function humMenuToggle() {
      var header = $('header');
      var humButton = $('#humButton');
      var hummenu = $('#hummenu');
      var menuState = 0;
      var current_scrollY;

      function humMenuShift() {
        console.log('menuState:' + menuState);
        if (menuState == 0) {
          current_scrollY = $(window).scrollTop();
          $('body').css({
            position: 'fixed',
            top: -1 * current_scrollY
          });
          $('body').addClass('fixed');
          hummenu.addClass('open');
          header.addClass('hum_open');
          menuState = 1;
        } else {
          $('body').removeClass('fixed');
          $('body').attr('style', '');
          $('html, body').prop({scrollTop: current_scrollY});
          hummenu.removeClass('open');
          header.removeClass('hum_open');
          menuState = 0;
        }
      }

      function init() {
        humButton.on({
          'click': function() {
            humMenuShift();
          }
        });
      }

      init()

    };

    humMenuToggle();

    // 商品詳細レイアウト サムネイルの切り替え
    function thumbSwitcher(target){
      let thumbButton = [];
      let thumbSrc = [];
      let thumbAlt = [];
      let thumbSrcSet = [];
      let thumbBox = target.find('.thumb_img');
      let caption = target.find('.caption');
      let thumbImage = thumbBox.find('img');
      const time = 300;

      function switchImage(num){
        thumbImage.stop().animate({ opacity: 0 }, time, function() {
            thumbImage.attr('src', thumbSrc[num]);
            thumbImage.attr('srcset', thumbSrcSet[num]);
            $('.active_thumb').removeClass('active_thumb');
            thumbButton[num].addClass('active_thumb');
            caption.html(thumbAlt[num]);
            thumbImage.stop().animate({ opacity: 1 }, time);
        });
      }

      function thumbHeightControll(){
        var thumbHeight = thumbImage.outerHeight();
        /*$('#thumnails').css({'max-height': thumbHeight + 'px'});*/
        /*requestAnimationFrame(thumbHeightControll);*/
      }

      function init(){
        thumbHeightControll();
        $.each(target.find('button'), function(index) {
          thumbButton[index] = $(this);
          thumbSrc[index] = $(this).find('img').attr("src");
          thumbSrcSet[index] = $(this).find('img').attr("srcset");
          thumbAlt[index] = $(this).find('img').attr("alt");
          thumbButton[index].on({
            'click': function() {
              switchImage(index);
            }
          });
        });
        $(window).on({
          'resize': function(){
            thumbHeightControll();
          }
        });
      }

      init();

    }

    if (document.getElementById('thumbnails01')) {
      thumbSwitcher($('#thumbnails01'));
    }

    if (document.getElementById('thumbnails02')) {
      thumbSwitcher($('#thumbnails02'));
    }

    //FAQ よくある質問
    function faqToggle(target) {
      var toggleItem = [];
      var toggleButton = [];
      var toggleContents = [];
      var toggleHeight = [];
      var toggleState = [];
      var toggleTitleTxt = [];
      var toggleContentsTxt = [];
      var faqSearch = $('#faqSearch');
      var faqFlex = $('#faqFlex');
      var windowW = window.innerWidth;

      function toggleMove(e) {
        if ( toggleState[e] == 0 ) {
          toggleItem[e].addClass('active');
          var buttonHeight = toggleButton[e].outerHeight();
          var targetHeight = toggleHeight[e].outerHeight();
          toggleItem[e].css({
            'height': buttonHeight + targetHeight + 'px'
          });
          toggleContents[e].css({
            'height': targetHeight + 1 + 'px'
          });
          toggleState[e] = 1;
        } else {
          toggleItem[e].removeClass('active');
          var buttonHeight = toggleButton[e].outerHeight();
            toggleItem[e].css({
              'height': buttonHeight + 1 + 'px'
            });
            toggleContents[e].css({
              'height': '0px'
            });
          toggleState[e] = 0;
        }
      }

      function setToggleHeight(){
        $.each(target.find('.toggle_item'), function(index) {
          toggleItem[index].removeClass('active');
          toggleItem[index] = $(this);
          toggleButton[index] = $(this).find('.toggle_button');
          toggleContents[index] = $(this).find('.toggle_contents');
          toggleHeight[index] = $(this).find('.contents_inner');
          toggleContents[index].css({'height': 0 + 'px'});
          $(this).css({'height': toggleButton[index].outerHeight() + 3 + 'px'});
          toggleState[index] = 0;
        });
      }

      function init() {
        $.each(target.find('.toggle_item'), function(index) {
          toggleItem[index] = $(this);
          toggleButton[index] = $(this).find('.toggle_button');
          toggleContents[index] = $(this).find('.toggle_contents');
          toggleHeight[index] = $(this).find('.contents_inner');
          $(this).css({'height': toggleButton[index].outerHeight() + 3 + 'px'});
          toggleState[index] = 0;
          toggleTitleTxt[index] = toggleButton[index].text();
          toggleContentsTxt[index] = toggleContents[index].text();
          toggleButton[index].on({
            'click': function() {
              toggleMove(index);
            }
          });
        });


        $(window).on(
          'resize', function() {
            setToggleHeight();
          }
        );
      }

      init();

    }

    if (document.getElementById('detailToggle')) {
      faqToggle($('body'));
    }


    //カートページ 購入個数の増減
    function controllProductQuantity(target){
      var minusButton = [];
      var plusButton = [];
      var quantityInput = [];
      var reloadButton = [];
      var quantityNum;

      function controllQuantity(num, vector){
        quantityNum = quantityInput[num].val();
        if(vector == 1){
          quantityInput[num].attr('value', Number(quantityNum) + 1);
          reloadButton[num].click();
        }else{
          if(quantityNum != 1){
            quantityInput[num].attr('value', Number(quantityNum) - 1);
            reloadButton[num].click();
          }
        }
      }

      function init(){
        $.each(target.find('.cart_item'), function(index) {
          minusButton[index] = $(this).find('.minus');
          plusButton[index] = $(this).find('.plus');
          quantityInput[index] = $(this).find('input[type="number"]');
          reloadButton[index] = $(this).find('.reload_button');
          minusButton[index].on({
            'click': function() {
              controllQuantity(index, -1);
            }
          });
          plusButton[index].on({
            'click': function() {
              controllQuantity(index, 1);
            }
          });
        });

      }

      init();

    }

    if (document.getElementById('cartItem')) {
      controllProductQuantity($('#cartItem'));
    }

    /* お問い合わせフォームのGAS連動とバリデーション */
    function setMyForm(target){
      console.log('setMyForm');
      var ERROR_MESSAGE_CLASSNAME = 'errorMsg'; //エラー時のメッセージ要素のclass名
      var ERROR_INPUT_CLASSNAME = 'errorInput'; //エラー時のinput要素のclass名
      var errorCount = 0;
      var submitWrap = $('#submit');
      var confirmButton = $('#confirm');
      var submitButton = $('#submitButton');
      var contactBackButton = $('#contactBackButton');
      var items = []; //チェック対象となるテキスト入力要素を格納した配列

      //項目チェックする
      var checkAll = function(){
        errorCount = 0;

        //input,textareaのチェック
        for( var i=0; i<items.length; i++ ){
          if( items[i].prop('isSuccess') == false ){
            errorCount++;
          };
        };

        console.log('errorCount:' + errorCount);

        if( errorCount == 0 ){
        }else{
        };
      };

      //エラーメッセージの追加
      var addErrorMessage = function(selector, msg){
        removeErrorMessage(selector);
        selector.parent('div').append('<span class="error '+ERROR_MESSAGE_CLASSNAME+'">'+msg+'</span>');
        selector.addClass(ERROR_INPUT_CLASSNAME);
      };

      //エラーメッセージの削除
      var removeErrorMessage = function(selector){
        var msgSelector = selector.parent('div').find('.'+ERROR_MESSAGE_CLASSNAME);
        if( msgSelector.length != 0 ){
          msgSelector.remove();
          selector.removeClass(ERROR_INPUT_CLASSNAME);
        };
      };

      //input,textareaの未入力チェック
      var checkEmptyText = function(selector, msg){
        if( selector.val() == '' ||  selector.val() == null){
          addErrorMessage(selector, msg);
          selector.prop('isSuccess', false);
        }else{
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        };
      };

      var emptyThrough = function(selector){
        if( selector.val() == '' ||  selector.val() == null){
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
        }
      };

      //radioの未入力チェック
      var checkRadioBox = function(selector, msg){
        if( selector.prop("checked")){
          removeErrorMessage(selector);
          selector.prop('isSuccess', true);
          submitWrap.removeClass('disabled');
        }else{
          addErrorMessage(selector, msg);
          selector.prop('isSuccess', false);
          submitWrap.addClass('disabled');
        };
      };

      //文字列のフォーマットチェック
      function checkFormatText(selector, _mode, msg){
        var value = selector.val();
        switch(_mode){
          //全角のみ
          case 0:
            if(value.match(/^[^ -~｡-ﾟ]*$/)){
              selector.prop('isSuccess', true);
              removeErrorMessage(selector);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //ふりがなのみ
          case 1:
            if(value.match(/^[\u3040-\u309F]+$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
          //半角数字とハイフンのみ
          case 2:
          if(value.match(/^[0-9\-]+$/) || value.length < 1){
            selector.prop('isSuccess', true);
          }else{
            selector.prop('isSuccess', false);
          };
          break;
          //メールアドレスかどうか
          case 3:
            if(value.match(/^[a-zA-Z0-9!$&*.=^`|~#%'+\/?_{}-]+@([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,6}$/)){
              selector.prop('isSuccess', true);
            }else{
              selector.prop('isSuccess', false);
            };
            break;
        };
        if( selector.prop('isSuccess') == false ){
          addErrorMessage(selector, msg);
        }else{
          removeErrorMessage(selector);
        };
      };

      //初期設定
      var init = function(){
        target.find('input[type=button]').attr('disabled', true);
        //submitイベントの設定
        target.on({
          'submit': function(){
            checkAll();
          }
        });
        //input要素を配列に格納
        items = [
          target.find('input[name="username"]'), //0 氏名
          target.find('input[name="usermail"]'), //1 メールアドレス
          target.find('input[name="telnumber"]'), //2 電話番号
          target.find('select[name="category"]'), //3 お問い合わせ種別
          target.find('textarea[name="content"]'), //4 お問い合わせ内容
        ];

        //input要素のプロパティを設定
        $.each(items, function(index){
          items[index].prop('isSuccess', false);
        });

        //enterキーでsubmitしてしまうのを防止する
        target.find('input[type=text]').on({
          'keypress': function(e){
            if( (e.keyCode == 13) ) return false;
          }
        });
        //0 氏名
        items[0].on({
          'blur': function(){
            checkEmptyText( items[0], '※氏名を入力してください。' );
            checkAll();
          }
        });
        //2 メールアドレス
        items[1].on({
          'blur': function(){
            checkEmptyText( items[1], '※メールアドレスをご入力ください。' );
            if( items[1].prop('isSuccess') ) checkFormatText( items[1], 3, '※アドレスの形式をご確認ください' );
            checkAll();
          }
        });
        //2 電話番号
        items[2].on({
          'blur': function(){
            checkEmptyText( items[2], '※電話番号を入力してください。' );
            if( items[2].prop('isSuccess') ) checkFormatText( items[2], 2, '※電話番号は数字で入力してください。');
            checkAll();
          }
        });
        //3 お問い合わせ種別
        items[3].on({
          'change': function(){
            checkEmptyText( items[3], '※項目を選択してください' );
            checkAll();
          }
        });
        //4 お問い合わせ内容
        items[4].on({
          'blur': function(){
            checkEmptyText( items[4], '※お問い合わせ内容を入力してください' );
            checkAll();
          }
        });

        //5 プラポリへの同意
        $(target.find('input[name=privacy]')).on({
          'click': function(){
            var privacyState = $('input[name="privacy"]:checked').val();
            if(privacyState == 1){
              submitButton.removeClass('disabled');
            }else{
              submitButton.addClass('disabled');
            }
          }
        });
        submitButton.on({
          'click': function(){
            checkEmptyText( items[0], '※氏名を入力してください。' );
            checkEmptyText( items[1], '※メールアドレスをご入力ください。' );
            checkEmptyText( items[2], '※電話番号を入力してください。' );
            checkEmptyText( items[3], '※項目を選択してください' );
            checkEmptyText( items[4], '※お問い合わせ内容を入力してください' );
            checkAll();
            if( errorCount == 0 ){
              contentCheck();
            }else{
              alert('入力内容に不備があります。入力内容を確認いただき、再度確認ボタンを押してください。');
              var scrollHeight = $('article').offset().top;
              $("html, body").animate({
                scrollTop: scrollHeight
              }, 300);
            };
          }
        })
      };

      function contentCheck(){
        var userName = target.find('input[name="username"]').val();
        var userMail = target.find('input[name="usermail"]').val();
        var telNumber = target.find('input[name="telnumber"]').val();
        var category = target.find('select[name="category"]').val();
        var content = target.find('textarea[name="content"]').val();
        processOrderContent();
      }

      function processOrderContent(){
        $('#ajaxLoader').addClass('loading');
        var userName = target.find('input[name="username"]').val();
        var userMail = target.find('input[name="usermail"]').val();
        var telNumber = target.find('input[name="telnumber"]').val();
        var category = target.find('select[name="category"]').val();
        var content = target.find('textarea[name="content"]').val();
        submitButton.addClass('disabled');
        event.preventDefault();
        $.ajax({
          url: "https://docs.google.com/forms/u/0/d/e/1FAIpQLSd642j8qWj7XBteZps95TSunViGhPz2lcZkXIj_XsiNxJbqUQ/formResponse",
          data: {
            "entry.1986630100": userName,
            "entry.1547819249": userMail,
            "entry.584991094": telNumber,
            "entry.178746866": category,
            "entry.1276392590": content
          },
          type: "POST",
          dataType: "xml",
          statusCode: {
            0: function () {
              setTimeout(function() {
                $('#ajaxLoader').removeClass('loading');
                $('#submitButton').addClass('completed');
                $('#statusMessage').addClass('complete').html('<span class="text">メッセージは送信されました。<br>自動返信メールをご確認ください。</span>');
              }, 2000);
            },
            200: function () {
              alert('メッセージ送信に失敗しました。お手数ではございますが、時間を置いてもう一度お試しください。');
              setTimeout(function() {
                location.href = 'https://' + location.hostname + '/';
              }, 500);
            }
          }
      });
    }

      init();

    };

    if (document.getElementById('contact')) {
      setMyForm($('#formWrap'));
    }

  }

  preSetScript();


  //PJAXの制御
  function pjaxControll(){
    var linkTarget = [];
    var linkURL = [];
    var humButton = $('#humButton button')
    function addPjaxClass() {
      $.each($('body').find('a'), function(index) {
        linkTarget[index] = $(this).attr('target');
        if(linkTarget[index] != '_blank' || linkTarget[index] == undefined ){
          $(this).addClass('pjax');
        }
      });
    }

    addPjaxClass();

    // pjax遷移開始
    var nextUrl = '';
    $(document).on('click', '.pjax', function(e) {
      var linkType = $(this).attr('target');
      var linkProp = $(this).attr('linkType');
      var linkURL = $(this).attr('href');

      if(linkType != '_blank' || linkType == undefined){
        if(linkURL != '/cart'){
          e.preventDefault();
          nextUrl = $(this).attr('href');
          if(linkProp == 'headerLink'){
            setTimeout(function() {
              $('#humButton').click();
            }, 300);
          }
          if(nextUrl.indexOf('logout') == -1){
            // 遷移先のURLを取得
            $('#container').animate({top:0}, 100, function(){
                $('#container').addClass('disnone');
                $.pjax({//エフェクトが終わったらPjaxイベント
                    url: nextUrl,
                    container: '#container',
                    fragment: '#container',
                    timeout: 5000,
                });
            });
          }else{
            location.href = nextUrl;
          }
        }
      }
    });

    //Pjaxイベントが終わったときの動作
    $(document).on('pjax:end', function() {
      preSetScript();
      addPjaxClass();
      $.each($('body').find('a'), function(index) {
      });
      $('#container').animate({ top: 0 }, 100, function() {
        $('#container').removeClass('disnone');
      });
    });

    // タイムアウト時
    $(document).on('pjax:timeout', function() {
      location.href = nextUrl;
      $('#container').animate({ top: 0 }, 100, function() {
        $('#container').removeClass('disnone');
      });
      preSetScript();
      addPjaxClass();
    });

  }

  pjaxControll();


});



// バナー用　2025年１０月追加
document.addEventListener("DOMContentLoaded", function() {
  const banner = document.getElementById('promo-banner');
  const closeBtn = document.querySelector('.promo-close');

  if (!banner || !closeBtn) return;

  // 1秒後にスライドイン
  setTimeout(() => {
    banner.classList.add('visible');
  }, 1000); // ← 1000ms = 1秒遅延

  // 閉じるボタン
  closeBtn.addEventListener('click', function() {
    banner.classList.remove('visible');
    setTimeout(() => {
      banner.style.display = 'none';
    }, 400);
  });
});

